import { api } from '@/lib/api/client';
import {
  createArticleCategoryApi,
  deleteArticleCategoryApi,
  getArticleApi,
  getArticleBySlugApi,
  getArticleCategoriesApi,
  getArticlesApi,
  getPublishedArticlesApi,
  updateArticleCategoryApi,
} from '@api-client/blog';

export { getArticlesApi, getArticleApi, getPublishedArticlesApi, getArticleBySlugApi, getArticleCategoriesApi };

// Lot A bis : les mutations de categories sont desormais scopees (club /
// organisation / plateforme). On delegue au client partage plutot que de
// dupliquer les URLs ici — la duplication precedente aurait silencieusement
// ignore le scope et reecrit dans la taxonomie BoulesConnect.
export { createArticleCategoryApi, updateArticleCategoryApi, deleteArticleCategoryApi };

export type {
  Article,
  ArticleCategory,
  ArticleCategoryScope,
  GetArticlesParams,
  CreateArticlePayload,
  UpdateArticlePayload,
} from '@api-client/blog';

export async function createArticleApi(
  data: import('@api-client/blog').CreateArticlePayload,
): Promise<import('@shared/types/entities').Article> {
  return api.post('/blog/articles', data);
}

export async function updateArticleApi(
  id: number,
  data: import('@api-client/blog').UpdateArticlePayload,
): Promise<import('@shared/types/entities').Article> {
  return api.patch(`/blog/articles/${id}`, data);
}

export async function deleteArticleApi(id: number): Promise<void> {
  return api.delete(`/blog/articles/${id}`);
}

export async function uploadArticleCoverApi(articleId: number, file: File): Promise<void> {
  const { uploadFileApi } = await import('@api-client/files');
  await uploadFileApi({
    usage: 'ARTICLE_COVER',
    file,
    extraFields: { articleId: String(articleId) },
  });
}
